import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../../helpers';

@Component({
    standalone: false,
    selector: 'box-analysis',
    templateUrl: "./box-analysis.component.html",
    encapsulation: ViewEncapsulation.None
})
export class BoxAnalysisComponent implements OnInit {
    @Input() iconsClass: string;
    @Input() description: string;
    @Input() boxTitle: string;
    @Input() colorClass: string;
    @Input() boxLink: string;

    constructor() {
    }

    ngOnInit() {
    }

}
